import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { SubmitResponse } from '@sgm-frontend/core';

export interface Setting<T = any> {
  id?: number;
  key: string;
  value: T;
  type: 'string' | 'boolean' | 'integer' | 'float' | 'json';
  is_public?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SettingService extends HttpService<any, Setting> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'settings');
  }

  // Public, unauthenticated — any setting flagged is_public can be read by the storefront.
  getPublic(key: string): Observable<Setting> {
    return this.getById(key) as Observable<Setting>;
  }

  // Admin-only — requires an authenticated admin session (enforced server-side).
  getAllAdmin(): Observable<Setting[]> {
    return this.getAll() as Observable<Setting[]>;
  }

  updateSetting(key: string, value: any, type: Setting['type'] = 'boolean', isPublic = true): Observable<SubmitResponse> {
    return this.update({ key, value, type, is_public: isPublic }, '', key);
  }
}
